import { render, staticRenderFns } from "./HistoryDashboard.vue?vue&type=template&id=9a2a3d10&scoped=true&"
import script from "./HistoryDashboard.vue?vue&type=script&lang=js&"
export * from "./HistoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDashboard.vue?vue&type=style&index=0&id=9a2a3d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2a3d10",
  null
  
)

export default component.exports